import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-circle-check-small',
  template: `
    <p>
      circle-check-small works!
    </p>
  `,
  styles: [
  ]
})
export class CircleCheckSmallComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
